import React, { act, useState } from "react";
import {
  FaEdit,
  FaDownload,
  FaInfo,
  FaShare,
  FaShieldAlt,
  FaRss,
} from "react-icons/fa";
import { LuFileClock, LuArrowDownWideNarrow } from "react-icons/lu";
import { RiInfoCardLine } from "react-icons/ri";
import { TbReplace } from "react-icons/tb";
import format from "date-fns/format";
import Barcode from "react-barcode";
import { Alert } from "react-bootstrap";
import { CustomTooltip } from "../../../components/CustomTooltip";
import { useRef } from "react";
import { FaPrint } from "react-icons/fa";
import AssetEditModal from "../ActionModal/AssetEditModal";
import { PiBarcodeBold } from "react-icons/pi";
import { RiRfidLine } from "react-icons/ri";
import AssetEditImage from "../ActionModal/AssetEditImage";
import { formatDateTimeWithAdd5Hours } from "../../../utilities";
import RFIDScannerModal from "../../../components/RFIDControlPanel/RFIDControlPanel";
import { AssetEditRFIDApi } from "../../../services/AssetService";
import { toast } from "react-toastify";


const AssetBasicDetails = ({ data, action }) => {
  const [codeType, setCodeType] = useState("rfid");
  const [rfidScanModal, setRfidScanModal] = useState(false);
  const [assetEditModal, setAssetEditModal] = useState(false);
  const [assetImageEditModal, setAssetImageEditModal] = useState(false);
  const [rfidEditModal, setRfidEditModal] = useState(false);
  const [scannedRfid, setScannedRfid] = useState('');
  const [loading, setLoading] = useState(false);

  const handleToggleAssetImageEditModal = () => {
    setAssetImageEditModal(!assetImageEditModal);
  };

  const handleToggleAssetEditModal = () => {
    setAssetEditModal(!assetEditModal);
  };
  // const handleAfterRfidSubmit = () => {
  //   handleToggleRfidEditModal();
  //   action();
  // };
  
  const handleToggleRfidScanModal = () => {
    setRfidScanModal(!rfidScanModal);
  };

  const handleAfterAssetEditSubmit = () => {
    handleToggleAssetEditModal();
    action();
  };
  const handleAfterAssetImageEditSubmit = () => {
    handleToggleAssetImageEditModal();
    action();
  };

  const barcodeValue = `${data?.asset_number || "UNKNOWN"}`;
  const svgRef = useRef();

  const handlePrint = () => {
    const svg = svgRef.current?.querySelector("svg");
    if (!svg) return;

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    const svgData = new XMLSerializer().serializeToString(svg);
    const htmlContent = `
      <html>
        <head>
          <title>Print Barcode</title>
          <style>
            body {
              margin: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100vh;
              background: white;
            }
            svg {
              max-width: 100%;
              height: auto;
            }
          </style>
        </head>
        <body>
          ${svgData}
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() {
                window.close();
              };
            };
          </script>
        </body>
      </html>
    `;

    printWindow.document.open();
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  const tabs = [
    {
      name: "RFID",
      icons: <RiRfidLine className="me-1" />,
      type: "rfid",
    },
    {
      name: "Barcode",
      icons: <PiBarcodeBold className="me-1" />,
      type: "barcode",
    },
  ];

  const expiryDate = data?.insurance?.insurance_expiry
    ? new Date(data.insurance.insurance_expiry)
    : null;
  const today = new Date();
  const thirtyDaysFromNow = new Date();
  thirtyDaysFromNow.setDate(today.getDate() + 30);

  let bgColor = "transparent";

  if (expiryDate) {
    if (expiryDate <= today) {
      bgColor = "#f8d7da"; // Expired - Light Red
    } else if (expiryDate > today && expiryDate <= thirtyDaysFromNow) {
      bgColor = "#fff3cd"; // Expiring Soon - Light Yellow
    }
  }

  const handleAfterRfidSubmit = (tag) =>{
    setScannedRfid(tag)
  }

  const handleSaveRfid = () => {
    if (!scannedRfid || !data?.id) return;

  setLoading(true);
  AssetEditRFIDApi(data.id, { rfid: scannedRfid })
    .then((res) => {
      toast.success(res?.data?.message || "RFID updated");
      setScannedRfid(null); // reset after sav
      action();
    })
    .catch((err) => {
      toast.error(err?.response?.data?.error || "Failed to update RFID");
    })
    .finally(() => setLoading(false));
  }

  return (
    <div className="row g-4">
      {/* Left Column - Asset Summary */}
      <div className="col-md-8">
        <div className="card h-100 shadow-sm rounded-3">
          <div className="card-body position-relative p-4">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <h4 className="mb-0">Asset Unit Details</h4>
              <button
                className="btn rounded-2 stylish-transparent-btn float-end"
                onClick={handleToggleAssetEditModal}
              >
                <FaEdit className="me-1" /> Edit Asset
              </button>
            </div>

            {data?.allocation?.allocation_type && (
              <div>
                <Alert variant={"info"}>
                  <div className="d-flex flex-sm-row flex-column align-items-sm-center align-items-start justify-content-between gap-2 w-100">
                    <div className="d-flex flex-column">
                      <span className="small">Allocated Area</span>
                      <span className="text-darker fw-medium">
                        {data?.allocation?.allocated_area?.name}
                      </span>
                    </div>

                    <div className="d-flex flex-column">
                      <span className="small">Allocation Type </span>
                      <span className="text-darker fw-medium">
                        {data?.allocation?.allocation_type}
                      </span>
                    </div>

                    <div className="d-flex flex-column">
                      <span className="small">Allocated To </span>
                      <span className="text-darker fw-medium">
                        {data?.allocation?.allocation_type === "EMPLOYEE"
                          ? data?.allocation?.allocated_to?.fullname
                          : data?.allocation?.allocated_to?.name}
                      </span>
                    </div>
                  </div>
                </Alert>
              </div>
            )}

            {data?.movement && (
              data?.movement?.from_location&&data?.movement?.to_location&&(
              <div>
                <Alert variant={"success"}>
                  <div className="d-flex flex-sm-row flex-column align-items-sm-center align-items-start justify-content-between gap-2 w-100">
                    <div className="d-flex flex-column align-items-center">
                      <TbReplace size={20} />
                      <span className="text-darker fw-medium">
                        Move Request
                      </span>
                    </div>
                    <div className="d-flex flex-column">
                      <span className="small">From Location</span>
                      <span className="text-darker fw-medium">
                        {data?.movement?.from_location?.name || "-"}
                      </span>
                    </div>

                    <div className="d-flex flex-column">
                      <span className="small">To Location </span>
                      <span className="text-darker fw-medium">
                        {data?.movement?.to_location?.name || "-"}
                      </span>
                    </div>

                    {/* <div className="d-flex flex-column">
                        <span className="small">Requested</span>
                        <span className="text-darker fw-medium">
                          {data?.movement?.requested_by?.fullname||'-'}
                        </span>
                      </div> */}
                  </div>
                </Alert>
              </div>
              )
            )}

            {data?.disposal && (
              <div>
                <Alert variant={"danger"}>
                  <div className="d-flex flex-sm-row flex-column align-items-sm-center align-items-start justify-content-between gap-2 w-100">
                    <div className="d-flex flex-column">
                      <span className="small">Disposal By</span>
                      <span className="text-darker fw-medium">
                        {data?.disposal?.disposed_by?.fullname || "-"}
                      </span>
                    </div>

                    <div className="d-flex flex-column">
                      <span className="small">Dsiposal Reason </span>
                      <span className="text-darker fw-medium">
                        {data?.disposal?.disposal_reason || "-"}
                      </span>
                    </div>

                    <div className="d-flex flex-column">
                      <span className="small">Date</span>
                      <span className="text-darker fw-medium">
                        {formatDateTimeWithAdd5Hours(
                          data?.disposal?.disposed_at
                        )}
                      </span>
                    </div>
                  </div>
                </Alert>
              </div>
            )}

            <div className="row g-3">
              <div className="col-sm-6">
                <div className="card p-2">
                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Manufacturer</span>
                    <span className="text-darker fw-medium">
                      {data?.manufacturer || "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Brand Name</span>
                    <span className="text-darker fw-medium">
                      {data?.brand || "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Model No.</span>
                    <span className="text-darker fw-medium">
                      {data?.model_number || "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Serial No.</span>
                    <span className="text-darker fw-medium">
                      {data?.serial_number || "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Manual Asset Id.</span>
                    <span className="text-darker fw-medium">
                      {data?.manual_asset_id || "N/A"}
                      <CustomTooltip
                        title="Manual Asset ID is the pre-existing code physically tagged on the asset (e.g., barcode, RFID tag, serial tag). Ensure it’s unique and correctly entered."
                        arrow
                        placement="right"
                      >
                        <span
                          className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                          style={{
                            cursor: "pointer",
                            padding: "0.2rem 0.2rem",
                          }}
                        >
                          <FaInfo size={9} className="text-dark" />
                        </span>
                      </CustomTooltip>
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="card p-2">
                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <span className="small">Purchase Date</span>
                    <span className="text-darker fw-medium">
                      {data?.purchase_date
                        ? format(new Date(data?.purchase_date), "dd MMM yyyy")
                        : "-"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <span className="small">Purchase Cost</span>
                    <span className="text-darker fw-medium">
                      {data?.purchase_cost ? `₹${data?.purchase_cost}` : "-"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <span className="small">Maintenance Cost</span>
                    <span className="text-darker fw-medium">
                      {data?.maintenance_cost
                        ? `- ₹${data?.maintenance_cost}`
                        : "-"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <span className="small">Depreciation Cost</span>
                    <span className="text-darker fw-medium">
                      {data?.depreciation_cost
                        ? `- ₹${data?.depreciation_cost}`
                        : "-"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <span className="small">Current Cost</span>
                    <span className="text-darker fw-medium">
                      {data?.current_cost ? (
                        <span className="bg-light p-1 rounded py-0">{`₹ ${data?.current_cost}`}</span>
                      ) : (
                        "-"
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="card p-2">
                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <h5 className="text-primary">
                      <FaShieldAlt className="me-1" /> Insurance Info
                    </h5>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Insurance Provider</span>
                    <span className="text-darker fw-medium">
                      {data?.insurance?.insurance_provider || "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Policy Number</span>
                    <span className="text-darker fw-medium">
                      {data?.insurance?.policy_number || "N/A"}
                    </span>
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-start gap-2"
                    style={{
                      backgroundColor: bgColor,
                      padding: "2px 2px",
                      borderRadius: "4px",
                      transition: "background-color 0.3s ease",
                    }}
                  >
                    <span className="small">Insurance Expiry</span>
                    <span className="text-darker fw-medium">
                      {data?.insurance?.insurance_expiry || "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Attachment</span>
                    <span className="text-darker fw-medium">
                      {data?.insurance?.insurance_attachment ? (
                        <button
                          className="btn btn-sm stylish-transparent-btn rounded-2"
                          onClick={() => {}}
                        >
                          <FaDownload className="me-1" /> Download
                        </button>
                      ) : (
                        "N/A"
                      )}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2 mt-2">
                    <h5 className="text-primary">
                      <LuFileClock className="me-1" /> Warranty Info
                    </h5>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Warranty Expiry</span>
                    <span className="text-darker fw-medium">
                      {data?.warranty?.warranty_end_date || "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Attachment</span>
                    <span className="text-darker fw-medium">
                      {data?.warranty?.warranty_attachment ? (
                        <button
                          className="btn btn-sm stylish-transparent-btn rounded-2"
                          onClick={() => {}}
                        >
                          <FaDownload className="me-1" /> Download
                        </button>
                      ) : (
                        "N/A"
                      )}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="card p-2">
                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <h5 className="text-primary">
                      <RiInfoCardLine className="me-1" /> Other Info
                    </h5>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Delivery Location</span>
                    <span className="text-darker fw-medium">
                      {data?.delivery_location?.name || "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">GRN Number</span>
                    <span className="text-darker fw-medium">
                      {data?.grn?.grn_number || "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Expected Lifespan</span>
                    <span className="text-darker fw-medium">
                      {data?.expected_lifespan_months
                        ? `${data?.expected_lifespan_months} Months`
                        : "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Service Cycle</span>
                    <span className="text-darker fw-medium">
                      {data?.service_cycle_months
                        ? `Every ${data?.service_cycle_months} Months`
                        : "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Scap Value</span>
                    <span className="text-darker fw-medium">
                      {data?.scrap_value ? `₹ ${data?.scrap_value}` : "N/A"}
                    </span>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2 mt-2">
                    <h5 className="text-primary">
                      <LuArrowDownWideNarrow className="me-1" /> Depreciation
                      Info
                    </h5>
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-2">
                    <span className="small">Depreciation Method</span>
                    <span className="text-darker fw-medium">
                      {data?.depreciation?.depreciation_method || "N/A"}
                    </span>
                  </div>
                  {data?.depreciation_rate && (
                    <div className="d-flex align-items-center justify-content-start gap-2">
                      <span className="small">Depreciation Rate</span>
                      <span className="text-darker fw-medium">
                        {data?.depreciation?.depreciation_rate
                          ? `${data?.depreciation?.depreciation_rate} % Per Month`
                          : "N/A"}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Column - Top: Asset Image */}
      <div className="col-md-4">
        <div className="card mb-4 rounded-3 shadow-sm">
          <div className="d-flex justify-content-between gap-2 px-2 pt-3">
            <ul className="nav flex-row custom-nav2">
              {tabs.map((tab) => (
                <li className="nav-item" key={tab.name}>
                  <span
                    className={`cursor-pointer nav-link ${
                      codeType == tab.type ? "active" : ""
                    }`}
                    style={{ fontSize: "0.75rem" }}
                    onClick={() => setCodeType(tab.type)}
                  >
                    {tab.icons}
                    {tab.name}
                  </span>
                </li>
              ))}
            </ul>
            {codeType == "barcode" ? (
              <button
                className="btn btn-sm stylish-transparent-btn rounded-2 align-self-center"
                onClick={handlePrint}
                style={{ padding: "0.1rem 0.4rem" }}
              >
                <FaPrint className="me-1" /> Print
              </button>
            ) : data?.rfid_tag_id ? (
              <button
                className="btn rounded-2 btn-sm stylish-transparent-btn align-self-center"
                onClick={handleToggleRfidScanModal}
                style={{ padding: "0.1rem 0.4rem" }}
              >
                <FaEdit className="me-1" />
                <span style={{ fontSize: "0.7rem" }}>Edit</span>
              </button>
            ) : null}
          </div>

          <div className="card-body position-relative">
            {codeType == "barcode" ? (
              <div className="text-center mb-1">
                <div ref={svgRef} style={{ width: "100%" }}>
                  <div
                    className="scroll-container"
                    style={{ width: "100%", overflowX: "auto" }}
                  >
                    <Barcode
                      value={barcodeValue}
                      format="CODE128"
                      displayValue={true}
                      background="#ffffff"
                      height={50}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div>
                {scannedRfid ? (
                  <div className="d-flex flex-column align-items-center mt-2">
                    <div
                      className="text-center fw-bold text-primary fs-5 mb-2"
                      style={{
                        letterSpacing: "1.5px",
                        backgroundColor: "#e6ffed",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        width: "fit-content",
                      }}
                    >
                      {scannedRfid}
                    </div>
                    <div className="d-flex gap-2 mt-2">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleSaveRfid(scannedRfid)}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => setScannedRfid("")}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : data?.rfid_tag_id ? (
                  <div
                    className="text-center fw-bold text-primary fs-4"
                    style={{
                      letterSpacing: "2px",
                      background:
                        "repeating-linear-gradient(45deg, #e0f7fa, #e0f7fa 10px, #f0fbfc 10px, #f0fbfc 20px)",
                      padding: "10px",
                    }}
                  >
                    {data?.rfid_tag_id || "-"}
                  </div>
                ) : (
                  <div className="d-flex flex-column align-items-center">
                    <div className="text-center fw-medium text-dark fs-6 mb-2">
                      No RFID Found
                    </div>
                    <button
                      className="btn btn-sm btn-success rounded-2 align-self-center"
                      onClick={handleToggleRfidScanModal}
                      style={{ padding: "0.1rem 0.4rem" }}
                    >
                      <FaRss className="me-1" />
                      <span style={{ fontSize: "0.7rem" }}>Scan RFID</span>
                    </button>
                  </div>
                )}
              </div>

            )}
          </div>
        </div>
        <div className="card mb-4 rounded-3 shadow-sm">
          <div className="card-body position-relative">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
              <h5 className="card-title">Asset Image</h5>
              <button
                className="btn rounded-2 btn-sm stylish-transparent-btn"
                onClick={handleToggleAssetImageEditModal}
              >
                <FaEdit className="me-1" /> Edit
              </button>
            </div>

            <div
              className="card rounded-2 overflow-hidden"
              style={{ height: "180px" }}
            >
              {data?.unit_image ? (
                <img
                  src={`${process.env.REACT_APP_BASE_URL}${data?.unit_image}`}
                  alt="Asset"
                  style={{
                    objectFit: "contain",
                    maxHeight: "180px",
                    width: "100%",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center text-white"
                  style={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: "#adb5bd",
                    fontSize: "1.1rem",
                    fontWeight: 500,
                  }}
                >
                  No Image Available
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <AssetBarcodeCard assetNumber={data?.asset_number} /> */}
      </div>
      {/* <AssetEditRFIDModal
        visible={rfidEditModal}
        onClose={handleToggleRfidEditModal}
        id={data?.id || ""}
        onAfterSubmit={handleAfterRfidSubmit}
        isRfid={data?.rfid_tag_id || ""}
      /> */}
      <AssetEditModal
        visible={assetEditModal}
        onClose={handleToggleAssetEditModal}
        data={data}
        afterSubmit={handleAfterAssetEditSubmit}
      />
      <AssetEditImage
        visible={assetImageEditModal}
        onClose={handleToggleAssetImageEditModal}
        id={data?.id || ""}
        onAfterSubmit={handleAfterAssetImageEditSubmit}
      />
      <RFIDScannerModal
        visible={rfidScanModal}
        onClose={() => setRfidScanModal(false)}
        onSuccess={(tag) => handleAfterRfidSubmit(tag)}
      />
    </div>
  );
};

export default AssetBasicDetails;
